import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import { buildProductStructuredData } from 'utils/StructuredData';
import { priceFormatter } from 'utils/Numbers';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import classes from './CardProductF.module.scss';

const CardProductF = (props) => {
  const {
    imageURI,
    imageAltText = '',
    imageHeight,
    imageWidth,
    displayName,
    description,
    price,
    originalPrice,
    button,
    isAffirmEligible,
  } = props;

  return (
    <div className={classes.container}>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: buildProductStructuredData(props) }}
      />
      <div className={classes.wrapper}>
        {imageURI &&
          <div className={classes.imageContainer}>
            <img
              className={classes.image}
              src={imageURI}
              alt={imageAltText}
              width={imageWidth}
              height={imageHeight}
              loading='lazy'
            />
          </div>}
        <div className={classes.productInfoContainer}>
          {displayName &&
            <div
              className={classes.displayName}
              dangerouslySetInnerHTML={{ __html: displayName }}
            />}
          {price >= 0 &&
            <div className={classes.price}>
              {priceFormatter(price)}
            </div>}
          {originalPrice > price &&
            <div className={classes.originalPrice}>
              {priceFormatter(originalPrice)}
            </div>}
          {price >= 0 &&
            <div className={classes.affirmMessage}>
              <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
            </div>}
          {description &&
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />}
          {button &&
            <div className={classes.itemContainer}>
              <div className={classes.button}>
                {BuildChildren(button)}
              </div>
            </div>}
        </div>
      </div>
    </div>
  );
};

CardProductF.propTypes = {
  /**
   * Product imaghe URI
  */
  imageURI: PropTypes.string,
  /**
   * Product imaghe alt text
  */
  imageAltText: PropTypes.string,
  /**
   * Product imaghe height
  */
  imageHeight: PropTypes.number,
  /**
   * Product imaghe width
  */
  imageWidth: PropTypes.number,
  /**
   * Product title that displays at the top of the card
  */
  displayName: PropTypes.string,
  /**
   * Product description
  */
  description: PropTypes.string,
  /**
   * Product price
  */
  price: PropTypes.number,
  /**
   * Product original price
  */
  originalPrice: PropTypes.number,
  /**
   * Add to cart button of the product
  */
  button: PropTypes.object,
  /**
   * Can you use affirm on this product
  */
  isAffirmEligible: PropTypes.bool,
};

export default CardProductF;
